function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _filter, _filter2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccount2(_ref, svgRef) {
  var _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, _ref102, _ref103, _ref104, _ref105, _ref106, _ref107, _ref108, _ref109, _ref110, _ref111, _ref112, _ref113, _ref114, _ref115, _ref116, _ref117, _ref118, _ref119, _ref120, _ref121, _ref122, _ref123, _ref124, _ref125, _ref126, _ref127, _ref128, _ref129, _ref130, _ref131, _ref132;
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3432_818)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3432_818)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M525.731 471H343.889V469.532H526L525.731 471Z",
    fill: "#3F3D56",
    style: (_ref2 = {
      fill: "#3F3D56"
    }, _defineProperty(_ref2, "fill", "color(display-p3 0.2471 0.2392 0.3373)"), _defineProperty(_ref2, "fillOpacity", 1), _ref2)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.13905 38.4986C5.79389 38.4986 7.94607 36.3724 7.94607 33.7496C7.94607 31.1267 5.79389 29.0005 3.13905 29.0005C0.484206 29.0005 -1.66797 31.1267 -1.66797 33.7496C-1.66797 36.3724 0.484206 38.4986 3.13905 38.4986Z",
    fill: "url(#paint0_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.473 38.4986C30.1279 38.4986 32.2801 36.3724 32.2801 33.7496C32.2801 31.1267 30.1279 29.0005 27.473 29.0005C24.8182 29.0005 22.666 31.1267 22.666 33.7496C22.666 36.3724 24.8182 38.4986 27.473 38.4986Z",
    fill: "url(#paint1_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8051 38.4986C54.4599 38.4986 56.6121 36.3724 56.6121 33.7496C56.6121 31.1267 54.4599 29.0005 51.8051 29.0005C49.1502 29.0005 46.998 31.1267 46.998 33.7496C46.998 36.3724 49.1502 38.4986 51.8051 38.4986Z",
    fill: "url(#paint2_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.139 38.4986C78.7939 38.4986 80.9461 36.3724 80.9461 33.7496C80.9461 31.1267 78.7939 29.0005 76.139 29.0005C73.4842 29.0005 71.332 31.1267 71.332 33.7496C71.332 36.3724 73.4842 38.4986 76.139 38.4986Z",
    fill: "url(#paint3_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.471 38.4986C103.126 38.4986 105.278 36.3724 105.278 33.7496C105.278 31.1267 103.126 29.0005 100.471 29.0005C97.8162 29.0005 95.6641 31.1267 95.6641 33.7496C95.6641 36.3724 97.8162 38.4986 100.471 38.4986Z",
    fill: "url(#paint4_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.805 38.4986C127.46 38.4986 129.612 36.3724 129.612 33.7496C129.612 31.1267 127.46 29.0005 124.805 29.0005C122.15 29.0005 119.998 31.1267 119.998 33.7496C119.998 36.3724 122.15 38.4986 124.805 38.4986Z",
    fill: "url(#paint5_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.137 38.4986C151.792 38.4986 153.944 36.3724 153.944 33.7496C153.944 31.1267 151.792 29.0005 149.137 29.0005C146.482 29.0005 144.33 31.1267 144.33 33.7496C144.33 36.3724 146.482 38.4986 149.137 38.4986Z",
    fill: "url(#paint6_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.471 38.4986C176.126 38.4986 178.278 36.3724 178.278 33.7496C178.278 31.1267 176.126 29.0005 173.471 29.0005C170.816 29.0005 168.664 31.1267 168.664 33.7496C168.664 36.3724 170.816 38.4986 173.471 38.4986Z",
    fill: "url(#paint7_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.805 38.4986C200.46 38.4986 202.612 36.3724 202.612 33.7496C202.612 31.1267 200.46 29.0005 197.805 29.0005C195.15 29.0005 192.998 31.1267 192.998 33.7496C192.998 36.3724 195.15 38.4986 197.805 38.4986Z",
    fill: "url(#paint8_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.13905 62.84C5.79389 62.84 7.94607 60.7137 7.94607 58.0909C7.94607 55.468 5.79389 53.3418 3.13905 53.3418C0.484206 53.3418 -1.66797 55.468 -1.66797 58.0909C-1.66797 60.7137 0.484206 62.84 3.13905 62.84Z",
    fill: "url(#paint9_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.473 62.84C30.1279 62.84 32.2801 60.7137 32.2801 58.0909C32.2801 55.468 30.1279 53.3418 27.473 53.3418C24.8182 53.3418 22.666 55.468 22.666 58.0909C22.666 60.7137 24.8182 62.84 27.473 62.84Z",
    fill: "url(#paint10_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8051 62.84C54.4599 62.84 56.6121 60.7137 56.6121 58.0909C56.6121 55.468 54.4599 53.3418 51.8051 53.3418C49.1502 53.3418 46.998 55.468 46.998 58.0909C46.998 60.7137 49.1502 62.84 51.8051 62.84Z",
    fill: "url(#paint11_radial_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.139 62.84C78.7939 62.84 80.9461 60.7137 80.9461 58.0909C80.9461 55.468 78.7939 53.3418 76.139 53.3418C73.4842 53.3418 71.332 55.468 71.332 58.0909C71.332 60.7137 73.4842 62.84 76.139 62.84Z",
    fill: "url(#paint12_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.471 62.84C103.126 62.84 105.278 60.7137 105.278 58.0909C105.278 55.468 103.126 53.3418 100.471 53.3418C97.8162 53.3418 95.6641 55.468 95.6641 58.0909C95.6641 60.7137 97.8162 62.84 100.471 62.84Z",
    fill: "url(#paint13_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.805 62.84C127.46 62.84 129.612 60.7137 129.612 58.0909C129.612 55.468 127.46 53.3418 124.805 53.3418C122.15 53.3418 119.998 55.468 119.998 58.0909C119.998 60.7137 122.15 62.84 124.805 62.84Z",
    fill: "url(#paint14_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.137 62.84C151.792 62.84 153.944 60.7137 153.944 58.0909C153.944 55.468 151.792 53.3418 149.137 53.3418C146.482 53.3418 144.33 55.468 144.33 58.0909C144.33 60.7137 146.482 62.84 149.137 62.84Z",
    fill: "url(#paint15_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.471 62.84C176.126 62.84 178.278 60.7137 178.278 58.0909C178.278 55.468 176.126 53.3418 173.471 53.3418C170.816 53.3418 168.664 55.468 168.664 58.0909C168.664 60.7137 170.816 62.84 173.471 62.84Z",
    fill: "url(#paint16_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.805 62.84C200.46 62.84 202.612 60.7137 202.612 58.0909C202.612 55.468 200.46 53.3418 197.805 53.3418C195.15 53.3418 192.998 55.468 192.998 58.0909C192.998 60.7137 195.15 62.84 197.805 62.84Z",
    fill: "url(#paint17_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.13905 87.1817C5.79389 87.1817 7.94607 85.0555 7.94607 82.4327C7.94607 79.8098 5.79389 77.6836 3.13905 77.6836C0.484206 77.6836 -1.66797 79.8098 -1.66797 82.4327C-1.66797 85.0555 0.484206 87.1817 3.13905 87.1817Z",
    fill: "url(#paint18_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.473 87.1817C30.1279 87.1817 32.2801 85.0555 32.2801 82.4327C32.2801 79.8098 30.1279 77.6836 27.473 77.6836C24.8182 77.6836 22.666 79.8098 22.666 82.4327C22.666 85.0555 24.8182 87.1817 27.473 87.1817Z",
    fill: "url(#paint19_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8051 87.1817C54.4599 87.1817 56.6121 85.0555 56.6121 82.4327C56.6121 79.8098 54.4599 77.6836 51.8051 77.6836C49.1502 77.6836 46.998 79.8098 46.998 82.4327C46.998 85.0555 49.1502 87.1817 51.8051 87.1817Z",
    fill: "url(#paint20_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.139 87.1817C78.7939 87.1817 80.9461 85.0555 80.9461 82.4327C80.9461 79.8098 78.7939 77.6836 76.139 77.6836C73.4842 77.6836 71.332 79.8098 71.332 82.4327C71.332 85.0555 73.4842 87.1817 76.139 87.1817Z",
    fill: "url(#paint21_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.471 87.1817C103.126 87.1817 105.278 85.0555 105.278 82.4327C105.278 79.8098 103.126 77.6836 100.471 77.6836C97.8162 77.6836 95.6641 79.8098 95.6641 82.4327C95.6641 85.0555 97.8162 87.1817 100.471 87.1817Z",
    fill: "url(#paint22_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.805 87.1817C127.46 87.1817 129.612 85.0555 129.612 82.4327C129.612 79.8098 127.46 77.6836 124.805 77.6836C122.15 77.6836 119.998 79.8098 119.998 82.4327C119.998 85.0555 122.15 87.1817 124.805 87.1817Z",
    fill: "url(#paint23_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.137 87.1817C151.792 87.1817 153.944 85.0555 153.944 82.4327C153.944 79.8098 151.792 77.6836 149.137 77.6836C146.482 77.6836 144.33 79.8098 144.33 82.4327C144.33 85.0555 146.482 87.1817 149.137 87.1817Z",
    fill: "url(#paint24_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.471 87.1817C176.126 87.1817 178.278 85.0555 178.278 82.4327C178.278 79.8098 176.126 77.6836 173.471 77.6836C170.816 77.6836 168.664 79.8098 168.664 82.4327C168.664 85.0555 170.816 87.1817 173.471 87.1817Z",
    fill: "url(#paint25_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.805 87.1817C200.46 87.1817 202.612 85.0555 202.612 82.4327C202.612 79.8098 200.46 77.6836 197.805 77.6836C195.15 77.6836 192.998 79.8098 192.998 82.4327C192.998 85.0555 195.15 87.1817 197.805 87.1817Z",
    fill: "url(#paint26_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.13905 111.523C5.79389 111.523 7.94607 109.397 7.94607 106.774C7.94607 104.151 5.79389 102.025 3.13905 102.025C0.484206 102.025 -1.66797 104.151 -1.66797 106.774C-1.66797 109.397 0.484206 111.523 3.13905 111.523Z",
    fill: "url(#paint27_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.473 111.523C30.1279 111.523 32.2801 109.397 32.2801 106.774C32.2801 104.151 30.1279 102.025 27.473 102.025C24.8182 102.025 22.666 104.151 22.666 106.774C22.666 109.397 24.8182 111.523 27.473 111.523Z",
    fill: "url(#paint28_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8051 111.523C54.4599 111.523 56.6121 109.397 56.6121 106.774C56.6121 104.151 54.4599 102.025 51.8051 102.025C49.1502 102.025 46.998 104.151 46.998 106.774C46.998 109.397 49.1502 111.523 51.8051 111.523Z",
    fill: "url(#paint29_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.139 111.523C78.7939 111.523 80.9461 109.397 80.9461 106.774C80.9461 104.151 78.7939 102.025 76.139 102.025C73.4842 102.025 71.332 104.151 71.332 106.774C71.332 109.397 73.4842 111.523 76.139 111.523Z",
    fill: "url(#paint30_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.471 111.523C103.126 111.523 105.278 109.397 105.278 106.774C105.278 104.151 103.126 102.025 100.471 102.025C97.8162 102.025 95.6641 104.151 95.6641 106.774C95.6641 109.397 97.8162 111.523 100.471 111.523Z",
    fill: "url(#paint31_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.805 111.523C127.46 111.523 129.612 109.397 129.612 106.774C129.612 104.151 127.46 102.025 124.805 102.025C122.15 102.025 119.998 104.151 119.998 106.774C119.998 109.397 122.15 111.523 124.805 111.523Z",
    fill: "url(#paint32_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.137 111.523C151.792 111.523 153.944 109.397 153.944 106.774C153.944 104.151 151.792 102.025 149.137 102.025C146.482 102.025 144.33 104.151 144.33 106.774C144.33 109.397 146.482 111.523 149.137 111.523Z",
    fill: "url(#paint33_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.471 111.523C176.126 111.523 178.278 109.397 178.278 106.774C178.278 104.151 176.126 102.025 173.471 102.025C170.816 102.025 168.664 104.151 168.664 106.774C168.664 109.397 170.816 111.523 173.471 111.523Z",
    fill: "url(#paint34_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.805 111.523C200.46 111.523 202.612 109.397 202.612 106.774C202.612 104.151 200.46 102.025 197.805 102.025C195.15 102.025 192.998 104.151 192.998 106.774C192.998 109.397 195.15 111.523 197.805 111.523Z",
    fill: "url(#paint35_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.13905 135.865C5.79389 135.865 7.94607 133.739 7.94607 131.116C7.94607 128.493 5.79389 126.367 3.13905 126.367C0.484206 126.367 -1.66797 128.493 -1.66797 131.116C-1.66797 133.739 0.484206 135.865 3.13905 135.865Z",
    fill: "url(#paint36_radial_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.473 135.865C30.1279 135.865 32.2801 133.739 32.2801 131.116C32.2801 128.493 30.1279 126.367 27.473 126.367C24.8182 126.367 22.666 128.493 22.666 131.116C22.666 133.739 24.8182 135.865 27.473 135.865Z",
    fill: "url(#paint37_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8051 135.865C54.4599 135.865 56.6121 133.739 56.6121 131.116C56.6121 128.493 54.4599 126.367 51.8051 126.367C49.1502 126.367 46.998 128.493 46.998 131.116C46.998 133.739 49.1502 135.865 51.8051 135.865Z",
    fill: "url(#paint38_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.139 135.865C78.7939 135.865 80.9461 133.739 80.9461 131.116C80.9461 128.493 78.7939 126.367 76.139 126.367C73.4842 126.367 71.332 128.493 71.332 131.116C71.332 133.739 73.4842 135.865 76.139 135.865Z",
    fill: "url(#paint39_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.471 135.865C103.126 135.865 105.278 133.739 105.278 131.116C105.278 128.493 103.126 126.367 100.471 126.367C97.8162 126.367 95.6641 128.493 95.6641 131.116C95.6641 133.739 97.8162 135.865 100.471 135.865Z",
    fill: "url(#paint40_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.805 135.865C127.46 135.865 129.612 133.739 129.612 131.116C129.612 128.493 127.46 126.367 124.805 126.367C122.15 126.367 119.998 128.493 119.998 131.116C119.998 133.739 122.15 135.865 124.805 135.865Z",
    fill: "url(#paint41_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.137 135.865C151.792 135.865 153.944 133.739 153.944 131.116C153.944 128.493 151.792 126.367 149.137 126.367C146.482 126.367 144.33 128.493 144.33 131.116C144.33 133.739 146.482 135.865 149.137 135.865Z",
    fill: "url(#paint42_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.471 135.865C176.126 135.865 178.278 133.739 178.278 131.116C178.278 128.493 176.126 126.367 173.471 126.367C170.816 126.367 168.664 128.493 168.664 131.116C168.664 133.739 170.816 135.865 173.471 135.865Z",
    fill: "url(#paint43_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.805 135.865C200.46 135.865 202.612 133.739 202.612 131.116C202.612 128.493 200.46 126.367 197.805 126.367C195.15 126.367 192.998 128.493 192.998 131.116C192.998 133.739 195.15 135.865 197.805 135.865Z",
    fill: "url(#paint44_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.13905 160.206C5.79389 160.206 7.94607 158.08 7.94607 155.457C7.94607 152.834 5.79389 150.708 3.13905 150.708C0.484206 150.708 -1.66797 152.834 -1.66797 155.457C-1.66797 158.08 0.484206 160.206 3.13905 160.206Z",
    fill: "url(#paint45_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.473 160.206C30.1279 160.206 32.2801 158.08 32.2801 155.457C32.2801 152.834 30.1279 150.708 27.473 150.708C24.8182 150.708 22.666 152.834 22.666 155.457C22.666 158.08 24.8182 160.206 27.473 160.206Z",
    fill: "url(#paint46_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8051 160.206C54.4599 160.206 56.6121 158.08 56.6121 155.457C56.6121 152.834 54.4599 150.708 51.8051 150.708C49.1502 150.708 46.998 152.834 46.998 155.457C46.998 158.08 49.1502 160.206 51.8051 160.206Z",
    fill: "url(#paint47_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.139 160.206C78.7939 160.206 80.9461 158.08 80.9461 155.457C80.9461 152.834 78.7939 150.708 76.139 150.708C73.4842 150.708 71.332 152.834 71.332 155.457C71.332 158.08 73.4842 160.206 76.139 160.206Z",
    fill: "url(#paint48_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.471 160.206C103.126 160.206 105.278 158.08 105.278 155.457C105.278 152.834 103.126 150.708 100.471 150.708C97.8162 150.708 95.6641 152.834 95.6641 155.457C95.6641 158.08 97.8162 160.206 100.471 160.206Z",
    fill: "url(#paint49_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.805 160.206C127.46 160.206 129.612 158.08 129.612 155.457C129.612 152.834 127.46 150.708 124.805 150.708C122.15 150.708 119.998 152.834 119.998 155.457C119.998 158.08 122.15 160.206 124.805 160.206Z",
    fill: "url(#paint50_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.137 160.206C151.792 160.206 153.944 158.08 153.944 155.457C153.944 152.834 151.792 150.708 149.137 150.708C146.482 150.708 144.33 152.834 144.33 155.457C144.33 158.08 146.482 160.206 149.137 160.206Z",
    fill: "url(#paint51_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.471 160.206C176.126 160.206 178.278 158.08 178.278 155.457C178.278 152.834 176.126 150.708 173.471 150.708C170.816 150.708 168.664 152.834 168.664 155.457C168.664 158.08 170.816 160.206 173.471 160.206Z",
    fill: "url(#paint52_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.805 160.206C200.46 160.206 202.612 158.08 202.612 155.457C202.612 152.834 200.46 150.708 197.805 150.708C195.15 150.708 192.998 152.834 192.998 155.457C192.998 158.08 195.15 160.206 197.805 160.206Z",
    fill: "url(#paint53_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.13905 184.548C5.79389 184.548 7.94607 182.422 7.94607 179.799C7.94607 177.176 5.79389 175.05 3.13905 175.05C0.484206 175.05 -1.66797 177.176 -1.66797 179.799C-1.66797 182.422 0.484206 184.548 3.13905 184.548Z",
    fill: "url(#paint54_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.473 184.548C30.1279 184.548 32.2801 182.422 32.2801 179.799C32.2801 177.176 30.1279 175.05 27.473 175.05C24.8182 175.05 22.666 177.176 22.666 179.799C22.666 182.422 24.8182 184.548 27.473 184.548Z",
    fill: "url(#paint55_radial_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8051 184.548C54.4599 184.548 56.6121 182.422 56.6121 179.799C56.6121 177.176 54.4599 175.05 51.8051 175.05C49.1502 175.05 46.998 177.176 46.998 179.799C46.998 182.422 49.1502 184.548 51.8051 184.548Z",
    fill: "url(#paint56_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.139 184.548C78.7939 184.548 80.9461 182.422 80.9461 179.799C80.9461 177.176 78.7939 175.05 76.139 175.05C73.4842 175.05 71.332 177.176 71.332 179.799C71.332 182.422 73.4842 184.548 76.139 184.548Z",
    fill: "url(#paint57_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.471 184.548C103.126 184.548 105.278 182.422 105.278 179.799C105.278 177.176 103.126 175.05 100.471 175.05C97.8162 175.05 95.6641 177.176 95.6641 179.799C95.6641 182.422 97.8162 184.548 100.471 184.548Z",
    fill: "url(#paint58_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.805 184.548C127.46 184.548 129.612 182.422 129.612 179.799C129.612 177.176 127.46 175.05 124.805 175.05C122.15 175.05 119.998 177.176 119.998 179.799C119.998 182.422 122.15 184.548 124.805 184.548Z",
    fill: "url(#paint59_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.137 184.548C151.792 184.548 153.944 182.422 153.944 179.799C153.944 177.176 151.792 175.05 149.137 175.05C146.482 175.05 144.33 177.176 144.33 179.799C144.33 182.422 146.482 184.548 149.137 184.548Z",
    fill: "url(#paint60_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.471 184.548C176.126 184.548 178.278 182.422 178.278 179.799C178.278 177.176 176.126 175.05 173.471 175.05C170.816 175.05 168.664 177.176 168.664 179.799C168.664 182.422 170.816 184.548 173.471 184.548Z",
    fill: "url(#paint61_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.805 184.548C200.46 184.548 202.612 182.422 202.612 179.799C202.612 177.176 200.46 175.05 197.805 175.05C195.15 175.05 192.998 177.176 192.998 179.799C192.998 182.422 195.15 184.548 197.805 184.548Z",
    fill: "url(#paint62_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.13905 208.889C5.79389 208.889 7.94607 206.763 7.94607 204.14C7.94607 201.517 5.79389 199.391 3.13905 199.391C0.484206 199.391 -1.66797 201.517 -1.66797 204.14C-1.66797 206.763 0.484206 208.889 3.13905 208.889Z",
    fill: "url(#paint63_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.473 208.889C30.1279 208.889 32.2801 206.763 32.2801 204.14C32.2801 201.517 30.1279 199.391 27.473 199.391C24.8182 199.391 22.666 201.517 22.666 204.14C22.666 206.763 24.8182 208.889 27.473 208.889Z",
    fill: "url(#paint64_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8051 208.889C54.4599 208.889 56.6121 206.763 56.6121 204.14C56.6121 201.517 54.4599 199.391 51.8051 199.391C49.1502 199.391 46.998 201.517 46.998 204.14C46.998 206.763 49.1502 208.889 51.8051 208.889Z",
    fill: "url(#paint65_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.139 208.889C78.7939 208.889 80.9461 206.763 80.9461 204.14C80.9461 201.517 78.7939 199.391 76.139 199.391C73.4842 199.391 71.332 201.517 71.332 204.14C71.332 206.763 73.4842 208.889 76.139 208.889Z",
    fill: "url(#paint66_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.471 208.889C103.126 208.889 105.278 206.763 105.278 204.14C105.278 201.517 103.126 199.391 100.471 199.391C97.8162 199.391 95.6641 201.517 95.6641 204.14C95.6641 206.763 97.8162 208.889 100.471 208.889Z",
    fill: "url(#paint67_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.805 208.889C127.46 208.889 129.612 206.763 129.612 204.14C129.612 201.517 127.46 199.391 124.805 199.391C122.15 199.391 119.998 201.517 119.998 204.14C119.998 206.763 122.15 208.889 124.805 208.889Z",
    fill: "url(#paint68_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.137 208.889C151.792 208.889 153.944 206.763 153.944 204.14C153.944 201.517 151.792 199.391 149.137 199.391C146.482 199.391 144.33 201.517 144.33 204.14C144.33 206.763 146.482 208.889 149.137 208.889Z",
    fill: "url(#paint69_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.471 208.889C176.126 208.889 178.278 206.763 178.278 204.14C178.278 201.517 176.126 199.391 173.471 199.391C170.816 199.391 168.664 201.517 168.664 204.14C168.664 206.763 170.816 208.889 173.471 208.889Z",
    fill: "url(#paint70_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.805 208.889C200.46 208.889 202.612 206.763 202.612 204.14C202.612 201.517 200.46 199.391 197.805 199.391C195.15 199.391 192.998 201.517 192.998 204.14C192.998 206.763 195.15 208.889 197.805 208.889Z",
    fill: "url(#paint71_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.13905 233.231C5.79389 233.231 7.94607 231.104 7.94607 228.482C7.94607 225.859 5.79389 223.732 3.13905 223.732C0.484206 223.732 -1.66797 225.859 -1.66797 228.482C-1.66797 231.104 0.484206 233.231 3.13905 233.231Z",
    fill: "url(#paint72_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.473 233.231C30.1279 233.231 32.2801 231.104 32.2801 228.482C32.2801 225.859 30.1279 223.732 27.473 223.732C24.8182 223.732 22.666 225.859 22.666 228.482C22.666 231.104 24.8182 233.231 27.473 233.231Z",
    fill: "url(#paint73_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8051 233.231C54.4599 233.231 56.6121 231.104 56.6121 228.482C56.6121 225.859 54.4599 223.732 51.8051 223.732C49.1502 223.732 46.998 225.859 46.998 228.482C46.998 231.104 49.1502 233.231 51.8051 233.231Z",
    fill: "url(#paint74_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.139 233.231C78.7939 233.231 80.9461 231.104 80.9461 228.482C80.9461 225.859 78.7939 223.732 76.139 223.732C73.4842 223.732 71.332 225.859 71.332 228.482C71.332 231.104 73.4842 233.231 76.139 233.231Z",
    fill: "url(#paint75_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.471 233.231C103.126 233.231 105.278 231.104 105.278 228.482C105.278 225.859 103.126 223.732 100.471 223.732C97.8162 223.732 95.6641 225.859 95.6641 228.482C95.6641 231.104 97.8162 233.231 100.471 233.231Z",
    fill: "url(#paint76_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.805 233.231C127.46 233.231 129.612 231.104 129.612 228.482C129.612 225.859 127.46 223.732 124.805 223.732C122.15 223.732 119.998 225.859 119.998 228.482C119.998 231.104 122.15 233.231 124.805 233.231Z",
    fill: "url(#paint77_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.137 233.231C151.792 233.231 153.944 231.104 153.944 228.482C153.944 225.859 151.792 223.732 149.137 223.732C146.482 223.732 144.33 225.859 144.33 228.482C144.33 231.104 146.482 233.231 149.137 233.231Z",
    fill: "url(#paint78_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.471 233.231C176.126 233.231 178.278 231.104 178.278 228.482C178.278 225.859 176.126 223.732 173.471 223.732C170.816 223.732 168.664 225.859 168.664 228.482C168.664 231.104 170.816 233.231 173.471 233.231Z",
    fill: "url(#paint79_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.805 233.231C200.46 233.231 202.612 231.104 202.612 228.482C202.612 225.859 200.46 223.732 197.805 223.732C195.15 223.732 192.998 225.859 192.998 228.482C192.998 231.104 195.15 233.231 197.805 233.231Z",
    fill: "url(#paint80_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.13905 257.572C5.79389 257.572 7.94607 255.446 7.94607 252.823C7.94607 250.2 5.79389 248.074 3.13905 248.074C0.484206 248.074 -1.66797 250.2 -1.66797 252.823C-1.66797 255.446 0.484206 257.572 3.13905 257.572Z",
    fill: "url(#paint81_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.473 257.572C30.1279 257.572 32.2801 255.446 32.2801 252.823C32.2801 250.2 30.1279 248.074 27.473 248.074C24.8182 248.074 22.666 250.2 22.666 252.823C22.666 255.446 24.8182 257.572 27.473 257.572Z",
    fill: "url(#paint82_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8051 257.572C54.4599 257.572 56.6121 255.446 56.6121 252.823C56.6121 250.2 54.4599 248.074 51.8051 248.074C49.1502 248.074 46.998 250.2 46.998 252.823C46.998 255.446 49.1502 257.572 51.8051 257.572Z",
    fill: "url(#paint83_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.139 257.572C78.7939 257.572 80.9461 255.446 80.9461 252.823C80.9461 250.2 78.7939 248.074 76.139 248.074C73.4842 248.074 71.332 250.2 71.332 252.823C71.332 255.446 73.4842 257.572 76.139 257.572Z",
    fill: "url(#paint84_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.471 257.572C103.126 257.572 105.278 255.446 105.278 252.823C105.278 250.2 103.126 248.074 100.471 248.074C97.8162 248.074 95.6641 250.2 95.6641 252.823C95.6641 255.446 97.8162 257.572 100.471 257.572Z",
    fill: "url(#paint85_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.805 257.572C127.46 257.572 129.612 255.446 129.612 252.823C129.612 250.2 127.46 248.074 124.805 248.074C122.15 248.074 119.998 250.2 119.998 252.823C119.998 255.446 122.15 257.572 124.805 257.572Z",
    fill: "url(#paint86_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.137 257.572C151.792 257.572 153.944 255.446 153.944 252.823C153.944 250.2 151.792 248.074 149.137 248.074C146.482 248.074 144.33 250.2 144.33 252.823C144.33 255.446 146.482 257.572 149.137 257.572Z",
    fill: "url(#paint87_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.471 257.572C176.126 257.572 178.278 255.446 178.278 252.823C178.278 250.2 176.126 248.074 173.471 248.074C170.816 248.074 168.664 250.2 168.664 252.823C168.664 255.446 170.816 257.572 173.471 257.572Z",
    fill: "url(#paint88_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.805 257.572C200.46 257.572 202.612 255.446 202.612 252.823C202.612 250.2 200.46 248.074 197.805 248.074C195.15 248.074 192.998 250.2 192.998 252.823C192.998 255.446 195.15 257.572 197.805 257.572Z",
    fill: "url(#paint89_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.75,
    filter: "url(#filter0_f_3432_818)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.394 94.7232C241.709 94.7232 242.969 95.2389 243.898 96.157C244.828 97.0752 245.35 98.3204 245.35 99.6188V295.443C245.35 296.086 245.222 296.723 244.972 297.317C244.723 297.911 244.358 298.45 243.898 298.905C243.438 299.36 242.892 299.72 242.291 299.966C241.689 300.212 241.045 300.339 240.394 300.339H98.1761C97.5253 300.339 96.8809 300.212 96.2797 299.966C95.6785 299.72 95.1322 299.36 94.6721 298.905C94.2119 298.45 93.8469 297.911 93.5979 297.317C93.3489 296.723 93.2207 296.086 93.2207 295.443V99.6188C93.2207 98.3204 93.7428 97.0751 94.6721 96.157C95.6014 95.2389 96.8618 94.7231 98.1761 94.7231L240.394 94.7232Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.78,
    d: "M82.7832 316.915H255.79V78.1465H82.7832V316.915Z",
    fill: "url(#paint90_radial_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.297 115.922C217.457 115.922 217.615 115.953 217.763 116.013C217.91 116.074 218.044 116.162 218.157 116.274C218.27 116.385 218.359 116.517 218.42 116.663C218.481 116.809 218.513 116.965 218.513 117.123V119.524C218.513 119.843 218.385 120.148 218.157 120.373C217.929 120.599 217.62 120.725 217.297 120.725H121.274C121.114 120.725 120.956 120.694 120.809 120.634C120.661 120.573 120.527 120.485 120.415 120.373C120.302 120.262 120.212 120.13 120.151 119.984C120.09 119.838 120.059 119.682 120.059 119.524V117.123C120.059 116.965 120.09 116.809 120.151 116.663C120.212 116.517 120.302 116.385 120.415 116.274C120.527 116.162 120.661 116.074 120.809 116.013C120.956 115.953 121.114 115.922 121.274 115.922H217.297Z",
    fill: "url(#paint91_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.297 127.33C217.62 127.33 217.929 127.457 218.157 127.682C218.385 127.907 218.513 128.212 218.513 128.531V130.933C218.513 131.251 218.385 131.557 218.157 131.782C217.929 132.007 217.62 132.133 217.297 132.133H121.274C121.114 132.133 120.956 132.102 120.809 132.042C120.661 131.982 120.527 131.893 120.415 131.782C120.302 131.67 120.212 131.538 120.151 131.392C120.09 131.246 120.059 131.09 120.059 130.933V128.531C120.059 128.373 120.09 128.217 120.151 128.071C120.212 127.926 120.302 127.793 120.415 127.682C120.527 127.57 120.661 127.482 120.809 127.421C120.956 127.361 121.114 127.33 121.274 127.33H217.297Z",
    fill: "url(#paint92_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.297 138.738C217.62 138.738 217.929 138.864 218.157 139.089C218.385 139.315 218.513 139.62 218.513 139.939V142.34C218.513 142.659 218.385 142.964 218.157 143.189C217.929 143.415 217.62 143.541 217.297 143.541H121.274C120.952 143.541 120.643 143.415 120.415 143.189C120.187 142.964 120.059 142.659 120.059 142.34V139.939C120.059 139.62 120.187 139.315 120.415 139.089C120.643 138.864 120.952 138.738 121.274 138.738H217.297Z",
    fill: "url(#paint93_radial_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.297 150.396C217.62 150.396 217.929 150.522 218.157 150.747C218.385 150.972 218.513 151.278 218.513 151.596V153.998C218.513 154.316 218.385 154.622 218.157 154.847C217.929 155.072 217.62 155.199 217.297 155.199H121.274C121.114 155.199 120.956 155.168 120.809 155.107C120.661 155.047 120.527 154.959 120.415 154.847C120.302 154.736 120.212 154.603 120.151 154.458C120.09 154.312 120.059 154.156 120.059 153.998V151.596C120.059 151.439 120.09 151.282 120.151 151.137C120.212 150.991 120.302 150.859 120.415 150.747C120.527 150.636 120.661 150.547 120.809 150.487C120.956 150.427 121.114 150.396 121.274 150.396H217.297Z",
    fill: "url(#paint94_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.297 161.803C217.62 161.803 217.929 161.93 218.157 162.155C218.385 162.38 218.513 162.686 218.513 163.004V165.406C218.513 165.563 218.481 165.72 218.42 165.865C218.359 166.011 218.27 166.143 218.157 166.255C218.044 166.366 217.91 166.455 217.763 166.515C217.615 166.576 217.457 166.607 217.297 166.607H121.274C121.114 166.607 120.956 166.576 120.809 166.515C120.661 166.455 120.527 166.366 120.415 166.255C120.302 166.143 120.212 166.011 120.151 165.865C120.09 165.72 120.059 165.563 120.059 165.406V163.004C120.059 162.846 120.09 162.69 120.151 162.545C120.212 162.399 120.302 162.266 120.415 162.155C120.527 162.043 120.661 161.955 120.809 161.895C120.956 161.834 121.114 161.803 121.274 161.803H217.297Z",
    fill: "url(#paint95_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.297 173.211C217.62 173.211 217.929 173.338 218.157 173.563C218.385 173.788 218.513 174.094 218.513 174.412V176.814C218.513 177.132 218.385 177.438 218.157 177.663C217.929 177.888 217.62 178.015 217.297 178.015H121.274C120.952 178.015 120.643 177.888 120.415 177.663C120.187 177.438 120.059 177.132 120.059 176.814V174.412C120.059 174.094 120.187 173.788 120.415 173.563C120.643 173.338 120.952 173.211 121.274 173.211H217.297Z",
    fill: "url(#paint96_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.75,
    filter: "url(#filter1_f_3432_818)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.76 222.205C136.504 222.205 136.258 222.306 136.077 222.485C135.895 222.665 135.793 222.907 135.793 223.161V267.566C135.793 267.819 135.895 268.062 136.077 268.241C136.258 268.421 136.504 268.521 136.76 268.522H201.645C201.901 268.521 202.147 268.421 202.328 268.241C202.51 268.062 202.612 267.819 202.612 267.566V223.161C202.612 222.907 202.51 222.665 202.328 222.485C202.147 222.306 201.901 222.205 201.645 222.205H136.76Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M121.886 211.587C121.512 211.587 121.153 211.734 120.888 211.996C120.624 212.257 120.475 212.611 120.475 212.981V277.745C120.475 278.115 120.624 278.469 120.888 278.731C121.153 278.992 121.512 279.139 121.886 279.14H216.519C216.893 279.139 217.252 278.992 217.516 278.731C217.781 278.469 217.93 278.115 217.93 277.745V212.981C217.93 212.611 217.781 212.257 217.516 211.996C217.252 211.734 216.893 211.587 216.519 211.587H121.886Z",
    fill: "url(#paint97_radial_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.603 141.348L168.609 141.087L190.288 60.52H316.031V61.5356H191.078L169.603 141.348Z",
    fill: "url(#paint98_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.563 61.0287C315.563 58.9115 316.193 56.8418 317.373 55.0814C318.553 53.3209 320.231 51.9489 322.193 51.1386C324.156 50.3284 326.316 50.1164 328.399 50.5294C330.483 50.9425 332.397 51.962 333.899 53.4592C335.401 54.9563 336.424 56.8637 336.839 58.9403C337.253 61.0169 337.04 63.1693 336.227 65.1253C335.414 67.0814 334.038 68.7533 332.271 69.9296C330.505 71.1059 328.428 71.7337 326.304 71.7337C323.456 71.7305 320.726 70.6016 318.712 68.5947C316.699 66.5878 315.566 63.8669 315.563 61.0287ZM336.022 61.0287C336.022 59.1131 335.452 57.2406 334.384 55.6478C333.316 54.055 331.799 52.8136 330.023 52.0805C328.247 51.3474 326.293 51.1557 324.408 51.5294C322.523 51.9031 320.791 52.8255 319.432 54.1801C318.073 55.5346 317.148 57.2604 316.773 59.1392C316.398 61.018 316.59 62.9654 317.326 64.7352C318.061 66.505 319.307 68.0176 320.905 69.0819C322.503 70.1461 324.382 70.7142 326.304 70.7142C328.88 70.7112 331.351 69.6899 333.172 67.8742C334.994 66.0584 336.019 63.5966 336.022 61.0287Z",
    fill: "url(#paint99_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.305 65.0883C328.575 65.0883 330.415 63.2704 330.415 61.028C330.415 58.7856 328.575 56.9678 326.305 56.9678C324.035 56.9678 322.195 58.7856 322.195 61.028C322.195 63.2704 324.035 65.0883 326.305 65.0883Z",
    fill: "url(#paint100_radial_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.241 277.797L167.233 278.059L145.399 358.585L19.6562 358.348L19.6584 357.332L144.611 357.569L166.241 277.797Z",
    fill: "url(#paint101_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.35937 357.8C-1.3553 355.683 -0.72137 353.614 0.462251 351.856C1.64587 350.098 3.32601 348.729 5.29023 347.922C7.25445 347.116 9.41453 346.908 11.4973 347.325C13.58 347.742 15.492 348.765 16.9912 350.265C18.4905 351.765 19.5098 353.675 19.9202 355.752C20.3307 357.829 20.1138 359.981 19.2971 361.936C18.4804 363.891 17.1005 365.56 15.3319 366.733C13.5633 367.906 11.4854 368.529 9.36102 368.525C6.51333 368.517 3.78537 367.383 1.77561 365.372C-0.234161 363.361 -1.36159 360.638 -1.35937 357.8ZM19.0997 357.839C19.1034 355.923 18.537 354.05 17.4722 352.455C16.4075 350.86 14.8921 349.616 13.1178 348.879C11.3434 348.143 9.38982 347.947 7.50398 348.317C5.61814 348.688 3.88477 349.607 2.52307 350.959C1.16137 352.311 0.2325 354.035 -0.146085 355.913C-0.524671 357.791 -0.335951 359.739 0.396183 361.51C1.12832 363.281 2.37098 364.796 3.96706 365.863C5.56314 366.931 7.44094 367.502 9.36299 367.506C11.9395 367.508 14.4116 366.491 16.2369 364.679C18.0623 362.867 19.0918 360.407 19.0997 357.839Z",
    fill: "url(#paint102_linear_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.38323 361.881C11.653 361.881 13.493 360.063 13.493 357.821C13.493 355.578 11.653 353.76 9.38323 353.76C7.11346 353.76 5.27344 355.578 5.27344 357.821C5.27344 360.063 7.11346 361.881 9.38323 361.881Z",
    fill: "url(#paint103_radial_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.19 447.63H401.939L403.234 407.975L422.398 408.998L409.19 447.63Z",
    fill: "#FFB8B8",
    style: (_ref3 = {
      fill: "#FFB8B8"
    }, _defineProperty(_ref3, "fill", "color(display-p3 1.0000 0.7216 0.7216)"), _defineProperty(_ref3, "fillOpacity", 1), _ref3)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.181 470.42C407.993 471.407 406.159 463.411 404.313 465.204C399.149 470.217 393.814 471.309 386.921 469.12L386.762 469.093C386.346 468.961 385.961 468.747 385.632 468.464C385.302 468.181 385.034 467.835 384.844 467.446C384.653 467.057 384.545 466.635 384.525 466.204C384.505 465.772 384.574 465.342 384.727 464.938C384.911 464.454 385.21 464.022 385.6 463.678C385.991 463.334 386.459 463.089 386.967 462.964L392.458 461.607L401.081 446.626L409.884 446.038C411.846 448.51 413.216 451.389 413.89 454.459C414.563 457.529 414.524 460.71 413.774 463.763C412.975 466.984 411.742 469.716 410.181 470.42Z",
    fill: "#2F2E41",
    style: (_ref4 = {
      fill: "#2F2E41"
    }, _defineProperty(_ref4, "fill", "color(display-p3 0.1843 0.1804 0.2549)"), _defineProperty(_ref4, "fillOpacity", 1), _ref4)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.078 442.388L471.335 445.023L457.775 407.677L475.977 401.665L478.078 442.388Z",
    fill: "#FFB8B8",
    style: (_ref5 = {
      fill: "#FFB8B8"
    }, _defineProperty(_ref5, "fill", "color(display-p3 1.0000 0.7216 0.7216)"), _defineProperty(_ref5, "fillOpacity", 1), _ref5)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.483 463.221C485.815 464.934 481.134 458.165 480.084 460.503C477.149 467.041 472.594 469.995 465.37 470.464L465.211 470.497C464.775 470.526 464.338 470.466 463.926 470.323C463.514 470.179 463.136 469.955 462.814 469.662C462.493 469.37 462.234 469.017 462.055 468.623C461.876 468.229 461.78 467.804 461.772 467.372C461.763 466.856 461.88 466.345 462.115 465.883C462.35 465.422 462.695 465.024 463.12 464.723L467.721 461.466L470.162 444.401L478.129 440.656C480.874 442.242 483.22 444.421 484.989 447.031C486.759 449.641 487.906 452.614 488.345 455.725C488.801 459.011 488.672 462 487.483 463.221Z",
    fill: "#2F2E41",
    style: (_ref6 = {
      fill: "#2F2E41"
    }, _defineProperty(_ref6, "fill", "color(display-p3 0.1843 0.1804 0.2549)"), _defineProperty(_ref6, "fillOpacity", 1), _ref6)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.065 250.906L444.933 253.734C444.091 253.948 443.211 253.973 442.357 253.807C441.504 253.641 440.699 253.289 440.001 252.775C439.304 252.262 438.732 251.601 438.327 250.84C437.922 250.08 437.694 249.239 437.661 248.381C437.63 247.591 437.764 246.804 438.055 246.068C438.345 245.332 438.786 244.663 439.35 244.102C439.914 243.542 440.588 243.102 441.331 242.81C442.075 242.519 442.871 242.381 443.67 242.407L453.476 242.719L472.371 235.922L454.512 222.764L456.583 204.343L491.388 231.948C492.009 232.441 492.52 233.054 492.889 233.75C493.259 234.447 493.479 235.211 493.535 235.995C493.631 237.314 493.26 238.624 492.487 239.703C491.714 240.782 490.587 241.562 489.296 241.911C481.141 248.487 469.26 250.5 456.065 250.906Z",
    fill: "#FFB8B8",
    style: (_ref7 = {
      fill: "#FFB8B8"
    }, _defineProperty(_ref7, "fill", "color(display-p3 1.0000 0.7216 0.7216)"), _defineProperty(_ref7, "fillOpacity", 1), _ref7)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.688 181.829C440.699 181.829 448.815 173.811 448.815 163.92C448.815 154.03 440.699 146.012 430.688 146.012C420.676 146.012 412.561 154.03 412.561 163.92C412.561 173.811 420.676 181.829 430.688 181.829Z",
    fill: "#FFB8B8",
    style: (_ref8 = {
      fill: "#FFB8B8"
    }, _defineProperty(_ref8, "fill", "color(display-p3 1.0000 0.7216 0.7216)"), _defineProperty(_ref8, "fillOpacity", 1), _ref8)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.957 188.481L428.615 198.203C429.33 190.601 427.313 182.993 422.918 176.713L443.117 172.107C442.854 178.202 446.19 183.65 452.957 188.481Z",
    fill: "#FFB8B8",
    style: (_ref9 = {
      fill: "#FFB8B8"
    }, _defineProperty(_ref9, "fill", "color(display-p3 1.0000 0.7216 0.7216)"), _defineProperty(_ref9, "fillOpacity", 1), _ref9)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.36 230.183C437.738 231.734 427.004 229.16 410.488 219.693L416.703 205.366C416.391 203.209 416.688 201.009 417.559 199.007C418.431 197.005 419.844 195.28 421.644 194.02L428.098 189.504L447.779 183.876L448.661 183.92C451.279 184.049 453.76 185.117 455.638 186.923C457.517 188.73 458.664 191.151 458.865 193.733C463.14 206.357 463.168 218.559 457.36 230.183Z",
    fill: "url(#paint104_radial_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.475 260.116L411.524 255.511L408.416 242.207C401.528 231.935 404.535 222.525 412.56 213.553C427.187 222.828 440.765 226.836 460.208 223.787C455.038 236.21 450.262 248.42 453.475 260.116Z",
    fill: "#2F2E41",
    style: (_ref10 = {
      fill: "#2F2E41"
    }, _defineProperty(_ref10, "fill", "color(display-p3 0.1843 0.1804 0.2549)"), _defineProperty(_ref10, "fillOpacity", 1), _ref10)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.104 415.155L452.698 413.364L441.822 327.914L433.017 412.852L393.396 411.061C405.483 355.222 413.879 302.212 411.524 253.464L452.957 257.046C467 271.674 473.972 295.024 478.077 322.797C482.181 350.57 485.489 382.766 486.104 415.155Z",
    fill: "#2F2E41",
    style: (_ref11 = {
      fill: "#2F2E41"
    }, _defineProperty(_ref11, "fill", "color(display-p3 0.1843 0.1804 0.2549)"), _defineProperty(_ref11, "fillOpacity", 1), _ref11)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.643 147.617C454.084 147.617 456.874 144.861 456.874 141.462C456.874 138.062 454.084 135.306 450.643 135.306C447.202 135.306 444.412 138.062 444.412 141.462C444.412 144.861 447.202 147.617 450.643 147.617Z",
    fill: "#2F2E41",
    style: (_ref12 = {
      fill: "#2F2E41"
    }, _defineProperty(_ref12, "fill", "color(display-p3 0.1843 0.1804 0.2549)"), _defineProperty(_ref12, "fillOpacity", 1), _ref12)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.222 139.955C444.324 138.393 445.025 136.928 446.182 135.859C447.339 134.791 448.865 134.198 450.449 134.201C450.321 134.185 450.193 134.166 450.062 134.157C448.413 134.052 446.789 134.599 445.548 135.677C444.307 136.755 443.551 138.276 443.444 139.905C443.338 141.534 443.892 143.139 444.983 144.365C446.074 145.591 447.614 146.338 449.263 146.443C449.394 146.452 449.523 146.448 449.653 146.449C448.081 146.252 446.644 145.471 445.635 144.264C444.626 143.058 444.121 141.517 444.222 139.955Z",
    fill: "#2F2E41",
    style: (_ref13 = {
      fill: "#2F2E41"
    }, _defineProperty(_ref13, "fill", "color(display-p3 0.1843 0.1804 0.2549)"), _defineProperty(_ref13, "fillOpacity", 1), _ref13)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.187 142.583C438.63 138.029 422.691 143.817 421.663 146.879C414.148 147.891 408.459 152.222 408.459 159.924C412.927 161.732 418.008 161.509 423.5 159.924C432.256 166.973 432.856 175.835 427.531 186.013L434.082 186.142L442.202 174.418L442.59 186.311L457.606 186.013V168.97C457.655 163.303 456.335 157.707 453.755 152.645C451.415 148.154 447.784 145.532 444.187 142.583Z",
    fill: "#2F2E41",
    style: (_ref14 = {
      fill: "#2F2E41"
    }, _defineProperty(_ref14, "fill", "color(display-p3 0.1843 0.1804 0.2549)"), _defineProperty(_ref14, "fillOpacity", 1), _ref14)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.204 172.694C431.85 172.694 433.184 170.849 433.184 168.573C433.184 166.297 431.85 164.452 430.204 164.452C428.559 164.452 427.225 166.297 427.225 168.573C427.225 170.849 428.559 172.694 430.204 172.694Z",
    fill: "#FFB8B8",
    style: (_ref15 = {
      fill: "#FFB8B8"
    }, _defineProperty(_ref15, "fill", "color(display-p3 1.0000 0.7216 0.7216)"), _defineProperty(_ref15, "fillOpacity", 1), _ref15)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.413 326.623C407.69 326.623 407.956 326.732 408.153 326.926C408.349 327.12 408.459 327.383 408.459 327.657V369.004C408.459 369.278 408.349 369.541 408.153 369.735C407.956 369.929 407.69 370.038 407.413 370.038H377.384C377.107 370.038 376.841 369.929 376.644 369.735C376.448 369.541 376.338 369.278 376.338 369.004V327.657C376.338 327.383 376.448 327.12 376.644 326.926C376.841 326.732 377.107 326.623 377.384 326.623H407.413Z",
    fill: "url(#paint105_radial_3432_818)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.525 311.284L412.539 328.649C412.604 329.767 412.417 330.885 411.99 331.922C411.563 332.96 410.908 333.89 410.072 334.646C409.236 335.402 408.24 335.965 407.157 336.293C406.073 336.621 404.929 336.707 403.808 336.544C399.342 335.895 399.241 331.581 400.336 327.254L404.506 310.772C414.738 274.528 417.5 238.953 416.983 204.258C416.962 203.082 417.182 201.913 417.631 200.823C418.08 199.733 418.747 198.744 419.593 197.916C420.439 197.087 421.447 196.437 422.554 196.004C423.662 195.571 424.847 195.364 426.037 195.396C427.199 195.43 428.342 195.689 429.402 196.161C430.461 196.633 431.416 197.306 432.211 198.144C433.006 198.981 433.625 199.966 434.033 201.041C434.441 202.116 434.63 203.26 434.589 204.407C433.141 245.148 427.126 282.146 411.525 311.284Z",
    fill: "#FFB8B8",
    style: (_ref16 = {
      fill: "#FFB8B8"
    }, _defineProperty(_ref16, "fill", "color(display-p3 1.0000 0.7216 0.7216)"), _defineProperty(_ref16, "fillOpacity", 1), _ref16)
  }))), /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3432_818",
    x: 76.2207,
    y: 77.7231,
    width: 186.129,
    height: 239.616,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5,
    result: "effect1_foregroundBlur_3432_818"
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_3432_818",
    x: 121.893,
    y: 208.305,
    width: 94.6184,
    height: 74.1164,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.95,
    result: "effect1_foregroundBlur_3432_818"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3432_818",
    x1: 3.13905,
    y1: 29.0005,
    x2: 3.13905,
    y2: 38.4986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref17 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref17, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref17, "stopOpacity", 1), _ref17)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3432_818",
    x1: 27.473,
    y1: 29.0005,
    x2: 27.473,
    y2: 38.4986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref18 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref18, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref18, "stopOpacity", 1), _ref18)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3432_818",
    x1: 51.8051,
    y1: 29.0005,
    x2: 51.8051,
    y2: 38.4986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref19 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref19, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref19, "stopOpacity", 1), _ref19)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3432_818",
    x1: 76.139,
    y1: 29.0005,
    x2: 76.139,
    y2: 38.4986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref20 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref20, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref20, "stopOpacity", 1), _ref20)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3432_818",
    x1: 100.471,
    y1: 29.0005,
    x2: 100.471,
    y2: 38.4986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref21 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref21, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref21, "stopOpacity", 1), _ref21)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3432_818",
    x1: 124.805,
    y1: 29.0005,
    x2: 124.805,
    y2: 38.4986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref22 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref22, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref22, "stopOpacity", 1), _ref22)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3432_818",
    x1: 149.137,
    y1: 29.0005,
    x2: 149.137,
    y2: 38.4986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref23 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref23, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref23, "stopOpacity", 1), _ref23)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3432_818",
    x1: 173.471,
    y1: 29.0005,
    x2: 173.471,
    y2: 38.4986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref24 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref24, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref24, "stopOpacity", 1), _ref24)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3432_818",
    x1: 197.805,
    y1: 29.0005,
    x2: 197.805,
    y2: 38.4986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref25 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref25, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref25, "stopOpacity", 1), _ref25)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3432_818",
    x1: 3.13905,
    y1: 53.3418,
    x2: 3.13905,
    y2: 62.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref26 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref26, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref26, "stopOpacity", 1), _ref26)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3432_818",
    x1: 27.473,
    y1: 53.3418,
    x2: 27.473,
    y2: 62.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref27 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref27, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref27, "stopOpacity", 1), _ref27)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_3432_818",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.8051 61.6288) rotate(-90) scale(7.14306 7.23021)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7C4FF",
    style: (_ref28 = {
      stopColor: "#A7C4FF"
    }, _defineProperty(_ref28, "stopColor", "color(display-p3 0.6531 0.7704 1.0000)"), _defineProperty(_ref28, "stopOpacity", 1), _ref28)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#558CF9",
    style: (_ref29 = {
      stopColor: "#558CF9"
    }, _defineProperty(_ref29, "stopColor", "color(display-p3 0.3329 0.5499 0.9748)"), _defineProperty(_ref29, "stopOpacity", 1), _ref29)
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3432_818",
    x1: 76.139,
    y1: 53.3418,
    x2: 76.139,
    y2: 62.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref30 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref30, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref30, "stopOpacity", 1), _ref30)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3432_818",
    x1: 100.471,
    y1: 53.3418,
    x2: 100.471,
    y2: 62.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref31 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref31, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref31, "stopOpacity", 1), _ref31)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3432_818",
    x1: 124.805,
    y1: 53.3418,
    x2: 124.805,
    y2: 62.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref32 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref32, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref32, "stopOpacity", 1), _ref32)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3432_818",
    x1: 149.137,
    y1: 53.3418,
    x2: 149.137,
    y2: 62.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref33 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref33, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref33, "stopOpacity", 1), _ref33)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3432_818",
    x1: 173.471,
    y1: 53.3418,
    x2: 173.471,
    y2: 62.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref34 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref34, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref34, "stopOpacity", 1), _ref34)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_3432_818",
    x1: 197.805,
    y1: 53.3418,
    x2: 197.805,
    y2: 62.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref35 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref35, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref35, "stopOpacity", 1), _ref35)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_3432_818",
    x1: 3.13905,
    y1: 77.6836,
    x2: 3.13905,
    y2: 87.1817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref36 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref36, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref36, "stopOpacity", 1), _ref36)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_3432_818",
    x1: 27.473,
    y1: 77.6836,
    x2: 27.473,
    y2: 87.1817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref37 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref37, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref37, "stopOpacity", 1), _ref37)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_3432_818",
    x1: 51.8051,
    y1: 77.6836,
    x2: 51.8051,
    y2: 87.1817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref38 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref38, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref38, "stopOpacity", 1), _ref38)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_3432_818",
    x1: 76.139,
    y1: 77.6836,
    x2: 76.139,
    y2: 87.1817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref39 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref39, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref39, "stopOpacity", 1), _ref39)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_3432_818",
    x1: 100.471,
    y1: 77.6836,
    x2: 100.471,
    y2: 87.1817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref40 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref40, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref40, "stopOpacity", 1), _ref40)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_3432_818",
    x1: 124.805,
    y1: 77.6836,
    x2: 124.805,
    y2: 87.1817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref41 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref41, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref41, "stopOpacity", 1), _ref41)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_3432_818",
    x1: 149.137,
    y1: 77.6836,
    x2: 149.137,
    y2: 87.1817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref42 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref42, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref42, "stopOpacity", 1), _ref42)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_3432_818",
    x1: 173.471,
    y1: 77.6836,
    x2: 173.471,
    y2: 87.1817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref43 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref43, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref43, "stopOpacity", 1), _ref43)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_3432_818",
    x1: 197.805,
    y1: 77.6836,
    x2: 197.805,
    y2: 87.1817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref44 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref44, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref44, "stopOpacity", 1), _ref44)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_3432_818",
    x1: 3.13905,
    y1: 102.025,
    x2: 3.13905,
    y2: 111.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref45 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref45, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref45, "stopOpacity", 1), _ref45)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_3432_818",
    x1: 27.473,
    y1: 102.025,
    x2: 27.473,
    y2: 111.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref46 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref46, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref46, "stopOpacity", 1), _ref46)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_3432_818",
    x1: 51.8051,
    y1: 102.025,
    x2: 51.8051,
    y2: 111.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref47 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref47, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref47, "stopOpacity", 1), _ref47)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_3432_818",
    x1: 76.139,
    y1: 102.025,
    x2: 76.139,
    y2: 111.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref48 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref48, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref48, "stopOpacity", 1), _ref48)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_3432_818",
    x1: 100.471,
    y1: 102.025,
    x2: 100.471,
    y2: 111.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref49 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref49, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref49, "stopOpacity", 1), _ref49)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_3432_818",
    x1: 124.805,
    y1: 102.025,
    x2: 124.805,
    y2: 111.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref50 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref50, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref50, "stopOpacity", 1), _ref50)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_3432_818",
    x1: 149.137,
    y1: 102.025,
    x2: 149.137,
    y2: 111.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref51 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref51, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref51, "stopOpacity", 1), _ref51)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_3432_818",
    x1: 173.471,
    y1: 102.025,
    x2: 173.471,
    y2: 111.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref52 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref52, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref52, "stopOpacity", 1), _ref52)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_3432_818",
    x1: 197.805,
    y1: 102.025,
    x2: 197.805,
    y2: 111.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref53 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref53, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref53, "stopOpacity", 1), _ref53)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_3432_818",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.13905 134.654) rotate(-90) scale(7.14306 7.23021)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7C4FF",
    style: (_ref54 = {
      stopColor: "#A7C4FF"
    }, _defineProperty(_ref54, "stopColor", "color(display-p3 0.6531 0.7704 1.0000)"), _defineProperty(_ref54, "stopOpacity", 1), _ref54)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#558CF9",
    style: (_ref55 = {
      stopColor: "#558CF9"
    }, _defineProperty(_ref55, "stopColor", "color(display-p3 0.3329 0.5499 0.9748)"), _defineProperty(_ref55, "stopOpacity", 1), _ref55)
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_3432_818",
    x1: 27.473,
    y1: 126.367,
    x2: 27.473,
    y2: 135.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref56 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref56, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref56, "stopOpacity", 1), _ref56)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_3432_818",
    x1: 51.8051,
    y1: 126.367,
    x2: 51.8051,
    y2: 135.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref57 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref57, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref57, "stopOpacity", 1), _ref57)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_3432_818",
    x1: 76.139,
    y1: 126.367,
    x2: 76.139,
    y2: 135.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref58 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref58, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref58, "stopOpacity", 1), _ref58)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_3432_818",
    x1: 100.471,
    y1: 126.367,
    x2: 100.471,
    y2: 135.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref59 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref59, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref59, "stopOpacity", 1), _ref59)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_3432_818",
    x1: 124.805,
    y1: 126.367,
    x2: 124.805,
    y2: 135.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref60 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref60, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref60, "stopOpacity", 1), _ref60)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_3432_818",
    x1: 149.137,
    y1: 126.367,
    x2: 149.137,
    y2: 135.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref61 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref61, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref61, "stopOpacity", 1), _ref61)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_3432_818",
    x1: 173.471,
    y1: 126.367,
    x2: 173.471,
    y2: 135.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref62 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref62, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref62, "stopOpacity", 1), _ref62)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_3432_818",
    x1: 197.805,
    y1: 126.367,
    x2: 197.805,
    y2: 135.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref63 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref63, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref63, "stopOpacity", 1), _ref63)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_3432_818",
    x1: 3.13905,
    y1: 150.708,
    x2: 3.13905,
    y2: 160.206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref64 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref64, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref64, "stopOpacity", 1), _ref64)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_3432_818",
    x1: 27.473,
    y1: 150.708,
    x2: 27.473,
    y2: 160.206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref65 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref65, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref65, "stopOpacity", 1), _ref65)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_3432_818",
    x1: 51.8051,
    y1: 150.708,
    x2: 51.8051,
    y2: 160.206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref66 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref66, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref66, "stopOpacity", 1), _ref66)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_3432_818",
    x1: 76.139,
    y1: 150.708,
    x2: 76.139,
    y2: 160.206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref67 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref67, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref67, "stopOpacity", 1), _ref67)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_3432_818",
    x1: 100.471,
    y1: 150.708,
    x2: 100.471,
    y2: 160.206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref68 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref68, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref68, "stopOpacity", 1), _ref68)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_3432_818",
    x1: 124.805,
    y1: 150.708,
    x2: 124.805,
    y2: 160.206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref69 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref69, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref69, "stopOpacity", 1), _ref69)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_3432_818",
    x1: 149.137,
    y1: 150.708,
    x2: 149.137,
    y2: 160.206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref70 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref70, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref70, "stopOpacity", 1), _ref70)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_3432_818",
    x1: 173.471,
    y1: 150.708,
    x2: 173.471,
    y2: 160.206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref71 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref71, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref71, "stopOpacity", 1), _ref71)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_3432_818",
    x1: 197.805,
    y1: 150.708,
    x2: 197.805,
    y2: 160.206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref72 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref72, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref72, "stopOpacity", 1), _ref72)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_3432_818",
    x1: 3.13905,
    y1: 175.05,
    x2: 3.13905,
    y2: 184.548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref73 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref73, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref73, "stopOpacity", 1), _ref73)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_3432_818",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.473 183.337) rotate(-90) scale(7.14306 7.23021)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7C4FF",
    style: (_ref74 = {
      stopColor: "#A7C4FF"
    }, _defineProperty(_ref74, "stopColor", "color(display-p3 0.6531 0.7704 1.0000)"), _defineProperty(_ref74, "stopOpacity", 1), _ref74)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#558CF9",
    style: (_ref75 = {
      stopColor: "#558CF9"
    }, _defineProperty(_ref75, "stopColor", "color(display-p3 0.3329 0.5499 0.9748)"), _defineProperty(_ref75, "stopOpacity", 1), _ref75)
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_3432_818",
    x1: 51.8051,
    y1: 175.05,
    x2: 51.8051,
    y2: 184.548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref76 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref76, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref76, "stopOpacity", 1), _ref76)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_3432_818",
    x1: 76.139,
    y1: 175.05,
    x2: 76.139,
    y2: 184.548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref77 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref77, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref77, "stopOpacity", 1), _ref77)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_3432_818",
    x1: 100.471,
    y1: 175.05,
    x2: 100.471,
    y2: 184.548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref78 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref78, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref78, "stopOpacity", 1), _ref78)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_3432_818",
    x1: 124.805,
    y1: 175.05,
    x2: 124.805,
    y2: 184.548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref79 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref79, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref79, "stopOpacity", 1), _ref79)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_3432_818",
    x1: 149.137,
    y1: 175.05,
    x2: 149.137,
    y2: 184.548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref80 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref80, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref80, "stopOpacity", 1), _ref80)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_3432_818",
    x1: 173.471,
    y1: 175.05,
    x2: 173.471,
    y2: 184.548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref81 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref81, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref81, "stopOpacity", 1), _ref81)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_3432_818",
    x1: 197.805,
    y1: 175.05,
    x2: 197.805,
    y2: 184.548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref82 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref82, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref82, "stopOpacity", 1), _ref82)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_3432_818",
    x1: 3.13905,
    y1: 199.391,
    x2: 3.13905,
    y2: 208.889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref83 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref83, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref83, "stopOpacity", 1), _ref83)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_3432_818",
    x1: 27.473,
    y1: 199.391,
    x2: 27.473,
    y2: 208.889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref84 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref84, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref84, "stopOpacity", 1), _ref84)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_3432_818",
    x1: 51.8051,
    y1: 199.391,
    x2: 51.8051,
    y2: 208.889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref85 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref85, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref85, "stopOpacity", 1), _ref85)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_3432_818",
    x1: 76.139,
    y1: 199.391,
    x2: 76.139,
    y2: 208.889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref86 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref86, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref86, "stopOpacity", 1), _ref86)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_3432_818",
    x1: 100.471,
    y1: 199.391,
    x2: 100.471,
    y2: 208.889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref87 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref87, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref87, "stopOpacity", 1), _ref87)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_3432_818",
    x1: 124.805,
    y1: 199.391,
    x2: 124.805,
    y2: 208.889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref88 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref88, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref88, "stopOpacity", 1), _ref88)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_3432_818",
    x1: 149.137,
    y1: 199.391,
    x2: 149.137,
    y2: 208.889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref89 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref89, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref89, "stopOpacity", 1), _ref89)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_3432_818",
    x1: 173.471,
    y1: 199.391,
    x2: 173.471,
    y2: 208.889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref90 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref90, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref90, "stopOpacity", 1), _ref90)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_3432_818",
    x1: 197.805,
    y1: 199.391,
    x2: 197.805,
    y2: 208.889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref91 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref91, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref91, "stopOpacity", 1), _ref91)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_3432_818",
    x1: 3.13905,
    y1: 223.732,
    x2: 3.13905,
    y2: 233.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref92 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref92, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref92, "stopOpacity", 1), _ref92)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_3432_818",
    x1: 27.473,
    y1: 223.732,
    x2: 27.473,
    y2: 233.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref93 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref93, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref93, "stopOpacity", 1), _ref93)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_3432_818",
    x1: 51.8051,
    y1: 223.732,
    x2: 51.8051,
    y2: 233.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref94 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref94, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref94, "stopOpacity", 1), _ref94)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_3432_818",
    x1: 76.139,
    y1: 223.732,
    x2: 76.139,
    y2: 233.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref95 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref95, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref95, "stopOpacity", 1), _ref95)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_3432_818",
    x1: 100.471,
    y1: 223.732,
    x2: 100.471,
    y2: 233.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref96 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref96, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref96, "stopOpacity", 1), _ref96)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_3432_818",
    x1: 124.805,
    y1: 223.732,
    x2: 124.805,
    y2: 233.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref97 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref97, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref97, "stopOpacity", 1), _ref97)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_3432_818",
    x1: 149.137,
    y1: 223.732,
    x2: 149.137,
    y2: 233.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref98 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref98, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref98, "stopOpacity", 1), _ref98)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_3432_818",
    x1: 173.471,
    y1: 223.732,
    x2: 173.471,
    y2: 233.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref99 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref99, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref99, "stopOpacity", 1), _ref99)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_3432_818",
    x1: 197.805,
    y1: 223.732,
    x2: 197.805,
    y2: 233.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref100 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref100, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref100, "stopOpacity", 1), _ref100)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_3432_818",
    x1: 3.13905,
    y1: 248.074,
    x2: 3.13905,
    y2: 257.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref101 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref101, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref101, "stopOpacity", 1), _ref101)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_3432_818",
    x1: 27.473,
    y1: 248.074,
    x2: 27.473,
    y2: 257.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref102 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref102, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref102, "stopOpacity", 1), _ref102)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_3432_818",
    x1: 51.8051,
    y1: 248.074,
    x2: 51.8051,
    y2: 257.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref103 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref103, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref103, "stopOpacity", 1), _ref103)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_3432_818",
    x1: 76.139,
    y1: 248.074,
    x2: 76.139,
    y2: 257.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref104 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref104, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref104, "stopOpacity", 1), _ref104)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_3432_818",
    x1: 100.471,
    y1: 248.074,
    x2: 100.471,
    y2: 257.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref105 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref105, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref105, "stopOpacity", 1), _ref105)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_3432_818",
    x1: 124.805,
    y1: 248.074,
    x2: 124.805,
    y2: 257.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref106 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref106, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref106, "stopOpacity", 1), _ref106)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_3432_818",
    x1: 149.137,
    y1: 248.074,
    x2: 149.137,
    y2: 257.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref107 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref107, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref107, "stopOpacity", 1), _ref107)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_3432_818",
    x1: 173.471,
    y1: 248.074,
    x2: 173.471,
    y2: 257.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref108 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref108, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref108, "stopOpacity", 1), _ref108)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_3432_818",
    x1: 197.805,
    y1: 248.074,
    x2: 197.805,
    y2: 257.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref109 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref109, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref109, "stopOpacity", 1), _ref109)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint90_radial_3432_818",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(169.287 286.47) rotate(-90) scale(179.565 130.11)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7C4FF",
    style: (_ref110 = {
      stopColor: "#A7C4FF"
    }, _defineProperty(_ref110, "stopColor", "color(display-p3 0.6531 0.7704 1.0000)"), _defineProperty(_ref110, "stopOpacity", 1), _ref110)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#558CF9",
    style: (_ref111 = {
      stopColor: "#558CF9"
    }, _defineProperty(_ref111, "stopColor", "color(display-p3 0.3329 0.5499 0.9748)"), _defineProperty(_ref111, "stopOpacity", 1), _ref111)
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_3432_818",
    x1: 169.286,
    y1: 115.922,
    x2: 169.286,
    y2: 120.725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref112 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref112, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref112, "stopOpacity", 1), _ref112)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_3432_818",
    x1: 169.286,
    y1: 127.33,
    x2: 169.286,
    y2: 132.133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref113 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref113, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref113, "stopOpacity", 1), _ref113)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint93_radial_3432_818",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(169.286 142.929) rotate(-90) scale(4.19085 85.9002)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7C4FF",
    style: (_ref114 = {
      stopColor: "#A7C4FF"
    }, _defineProperty(_ref114, "stopColor", "color(display-p3 0.6531 0.7704 1.0000)"), _defineProperty(_ref114, "stopOpacity", 1), _ref114)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#558CF9",
    style: (_ref115 = {
      stopColor: "#558CF9"
    }, _defineProperty(_ref115, "stopColor", "color(display-p3 0.3329 0.5499 0.9748)"), _defineProperty(_ref115, "stopOpacity", 1), _ref115)
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_3432_818",
    x1: 169.286,
    y1: 150.396,
    x2: 169.286,
    y2: 155.199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref116 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref116, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref116, "stopOpacity", 1), _ref116)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_3432_818",
    x1: 169.286,
    y1: 161.803,
    x2: 169.286,
    y2: 166.607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref117 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref117, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref117, "stopOpacity", 1), _ref117)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_3432_818",
    x1: 169.286,
    y1: 173.211,
    x2: 169.286,
    y2: 178.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref118 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref118, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref118, "stopOpacity", 1), _ref118)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint97_radial_3432_818",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(169.202 279.14) rotate(-90) scale(42.0075 60.6025)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7C4FF",
    style: (_ref119 = {
      stopColor: "#A7C4FF"
    }, _defineProperty(_ref119, "stopColor", "color(display-p3 0.6531 0.7704 1.0000)"), _defineProperty(_ref119, "stopOpacity", 1), _ref119)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#558CF9",
    style: (_ref120 = {
      stopColor: "#558CF9"
    }, _defineProperty(_ref120, "stopColor", "color(display-p3 0.3329 0.5499 0.9748)"), _defineProperty(_ref120, "stopOpacity", 1), _ref120)
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_3432_818",
    x1: 242.32,
    y1: 60.52,
    x2: 242.32,
    y2: 141.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref121 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref121, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref121, "stopOpacity", 1), _ref121)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_3432_818",
    x1: 337.045,
    y1: 61.0287,
    x2: 315.563,
    y2: 61.0287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref122 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref122, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref122, "stopOpacity", 1), _ref122)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint100_radial_3432_818",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(326.305 64.0528) rotate(-90) scale(6.10701 6.18151)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7C4FF",
    style: (_ref123 = {
      stopColor: "#A7C4FF"
    }, _defineProperty(_ref123, "stopColor", "color(display-p3 0.6531 0.7704 1.0000)"), _defineProperty(_ref123, "stopOpacity", 1), _ref123)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#558CF9",
    style: (_ref124 = {
      stopColor: "#558CF9"
    }, _defineProperty(_ref124, "stopColor", "color(display-p3 0.3329 0.5499 0.9748)"), _defineProperty(_ref124, "stopOpacity", 1), _ref124)
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_3432_818",
    x1: 93.4449,
    y1: 277.797,
    x2: 93.4449,
    y2: 358.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E2E2",
    style: (_ref125 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref125, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref125, "stopOpacity", 1), _ref125)
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_3432_818",
    x1: -1.35938,
    y1: 357.82,
    x2: 20.1226,
    y2: 357.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2",
    style: (_ref126 = {
      stopColor: "#E2E2E2"
    }, _defineProperty(_ref126, "stopColor", "color(display-p3 0.8863 0.8863 0.8863)"), _defineProperty(_ref126, "stopOpacity", 1), _ref126)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint103_radial_3432_818",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.38323 360.845) rotate(-90) scale(6.10701 6.18152)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7C4FF",
    style: (_ref127 = {
      stopColor: "#A7C4FF"
    }, _defineProperty(_ref127, "stopColor", "color(display-p3 0.6531 0.7704 1.0000)"), _defineProperty(_ref127, "stopOpacity", 1), _ref127)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#558CF9",
    style: (_ref128 = {
      stopColor: "#558CF9"
    }, _defineProperty(_ref128, "stopColor", "color(display-p3 0.3329 0.5499 0.9748)"), _defineProperty(_ref128, "stopOpacity", 1), _ref128)
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint104_radial_3432_818",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(436.201 224.645) rotate(-90) scale(35.1414 38.6746)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7C4FF",
    style: (_ref129 = {
      stopColor: "#A7C4FF"
    }, _defineProperty(_ref129, "stopColor", "color(display-p3 0.6531 0.7704 1.0000)"), _defineProperty(_ref129, "stopOpacity", 1), _ref129)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#558CF9",
    style: (_ref130 = {
      stopColor: "#558CF9"
    }, _defineProperty(_ref130, "stopColor", "color(display-p3 0.3329 0.5499 0.9748)"), _defineProperty(_ref130, "stopOpacity", 1), _ref130)
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint105_radial_3432_818",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(392.398 364.502) rotate(-90) scale(32.6497 24.1566)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7C4FF",
    style: (_ref131 = {
      stopColor: "#A7C4FF"
    }, _defineProperty(_ref131, "stopColor", "color(display-p3 0.6531 0.7704 1.0000)"), _defineProperty(_ref131, "stopOpacity", 1), _ref131)
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#558CF9",
    style: (_ref132 = {
      stopColor: "#558CF9"
    }, _defineProperty(_ref132, "stopColor", "color(display-p3 0.3329 0.5499 0.9748)"), _defineProperty(_ref132, "stopOpacity", 1), _ref132)
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3432_818"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3432_818"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 552,
    height: 442,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(-26 29)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount2);
export default __webpack_public_path__ + "static/media/Account-2.73f82f1c2ca647278ee47ab99a2b6461.svg";
export { ForwardRef as ReactComponent };